import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class ClearingService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    loanChequeClearing(loanOutwardClearingData: any): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'clearing/loan', loanOutwardClearingData).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getByWindowId(windowId: number): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `clearing/${windowId}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getForReconciliation(fromDate: Date, toDate: Date): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `clearing/dates/${fromDate}?toDate=${toDate}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    authorise(id: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'clearing/authorise', id).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    saveReconciliation(clearingData: any): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'clearing/reconciliation', clearingData).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
}
